import { mapActions } from 'vuex';

import Events from '_utils/events';
import { _DELETE_MANAGER_ } from './ManagerModel';

export default {
  name: 'manager-actions',
  data() {
    return {
      selectManager: null,
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert', 'deleteManager']),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.deleteManager(this.selectManager)
        .then(() => {
          this.close();
          Events.$emit('update:pagination_manager_list', false);
          this.activeAlert({
            message: 'Gerente deletado com sucesso',
            theme: 'success',
          });
        })
        .catch(error =>
          this.activeAlert({ message: error.message, theme: 'danger' })
        );
    },
  },
  mounted() {
    Events.$on(_DELETE_MANAGER_, manager => {
      this.setToggle({ type: 'confirm_modal', bool: true });
      this.selectManager = manager.id;
    });
  },
  destroyed() {
    Events.$off(_DELETE_MANAGER_);
  },
};
